import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { Substitution } from "@msuite/utils/types";
import React from "react";
import { ProcessSubstitutionPlan } from "./process-substitution-plan";

export function RowActions({ cell }: CellContext<Substitution, "actions">) {
	/** Render */
	return (
		<React.Fragment>
			<RowActionsWrapper
				to={
					cell.row.original.substitutionPlanId
						? `/substitutions/${cell.row.original.substitutionPlanId}`
						: undefined
				}
			>
				<ProcessSubstitutionPlan substitution={cell.row.original} />
			</RowActionsWrapper>
		</React.Fragment>
	);
}
